var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "theme-previewer-lib": "static-1.50553"
    },
    "depPathPrefixes": {
      "theme-previewer-lib": "/theme-previewer-lib/static-1.50553"
    },
    "project": "theme-previewer-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};